// src/app/app.routing.module.ts
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './components/landing/landing.component';
import { HomeComponent } from './components/home/home.component';
import { privacyGuard } from './services/privacy-guard/privacy.guard';
import { PageNotFoundComponent } from './shared/components/pagenotfound/pagenotfound.component';
import { SubmissionSuccessComponent } from './components/home/submission-success/submission-success.component';
import { SubmissionGuard } from './services/submission-guard/submission-guard.service';

// Define your routes here
const routes: Routes = [
  { path: '', component: LandingComponent }, // Landing page route
  {
    path: 'generate-invoice',
    component: HomeComponent,
    canActivate: [privacyGuard],
  },
  {
    path: 'submission-success',
    component: SubmissionSuccessComponent,
    canActivate: [SubmissionGuard],
  },
  // Details page route
  { path: '**', component: PageNotFoundComponent },
  // Wildcard route for 404 page
];

@NgModule({
  imports: [RouterModule.forRoot(routes)], // Use RouterModule to register routes
  exports: [RouterModule], // Export RouterModule to be used in other modules
})
export class AppRoutingModule { }
